import { apiClient } from "../apiClient"

export const CO_SO_RESOURCE = "co-so"
export const coSoApi = {
    SelectAll: () => apiClient.get(`${CO_SO_RESOURCE}`)
}